import { Nl2Br } from '@findy-code/yuffie/shared/nl2br';
import { Heading } from '@findy-code/yuffie/ui/heading';
import { Stack } from '@findy-code/yuffie/ui/stack';

import styles from '../styles.module.scss';

type Props = {
  mustSkills: string;
  desiredSkills: string;
  personality: string;
  rewarding: string;
  speakerDeckOembed?: {
    html: string;
  } | null;
};

export const RequiredSkills = ({
  mustSkills,
  desiredSkills,
  personality,
  rewarding,
  speakerDeckOembed,
}: Props) => {
  return (
    <Stack spacing="l">
      <Stack spacing="l">
        <Heading as="h3" font="heading-m">
          必須スキル/経験
        </Heading>
        <pre className={styles.pre}>
          <Nl2Br addLink text={mustSkills} />
        </pre>
      </Stack>
      <Stack spacing="l">
        <Heading as="h3" font="heading-m">
          歓迎スキル/経験
        </Heading>
        <pre className={styles.pre}>
          <Nl2Br addLink text={desiredSkills} />
        </pre>
      </Stack>
      <Stack spacing="l">
        <Heading as="h3" font="heading-m">
          求める人物像
        </Heading>
        <pre className={styles.pre}>
          <Nl2Br addLink text={personality} />
        </pre>
      </Stack>
      {speakerDeckOembed && (
        <Stack spacing="l">
          <Heading as="h3" font="heading-m">
            紹介資料
          </Heading>
          <div
            className={styles.slideWrapper}
            dangerouslySetInnerHTML={{
              __html: speakerDeckOembed.html,
            }}
          />
        </Stack>
      )}
      <Stack spacing="l">
        <Heading as="h3" font="heading-m">
          仕事の魅力
        </Heading>
        <pre className={styles.pre}>
          <Nl2Br addLink text={rewarding} />
        </pre>
      </Stack>
    </Stack>
  );
};
